module.exports = __webpack_public_path__ + "img/other13.b255f191.svg";